// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientInfo_container__37_1S","title":"ClientInfo_title__2d7y8","form":"ClientInfo_form__xqqCx","footer":"ClientInfo_footer__3xao_","button":"ClientInfo_button__2JSkb"};